export const shadows = {
  sm: "0 2px 6px rgba(15,23,42,.05)",
  md: "0 8px 24px rgba(15,23,42,.08)",
  lg: "0 16px 40px rgba(15,23,42,.12)",
};